const PINYIN_BY_CHAR: Record<string, string> = {
  漫: 'man',
  画: 'hua',
  榜: 'bang',
  单: 'dan',
  工: 'gong',
  作: 'zuo',
  台: 'tai',
  首: 'shou',
  页: 'ye',
  管: 'guan',
  理: 'li',
  登: 'deng',
  录: 'lu',
  注: 'zhu',
  册: 'ce',
  结: 'jie',
  果: 'guo',
  分: 'fen',
  析: 'xi',
  监: 'jian',
  控: 'kong',
  表: 'biao',
  基: 'ji',
  础: 'chu',
  步: 'bu',
  填: 'tian',
  写: 'xie',
  转: 'zhuan',
  账: 'zhang',
  信: 'xin',
  息: 'xi',
  确: 'que',
  认: 'ren',
  完: 'wan',
  成: 'cheng',
  高: 'gao',
  级: 'ji',
  查: 'cha',
  询: 'xun',
  标: 'biao',
  准: 'zhun',
  卡: 'ka',
  片: 'pian',
  文: 'wen',
  章: 'zhang',
  应: 'ying',
  用: 'yong',
  详: 'xiang',
  情: 'qing',
  异: 'yi',
  常: 'chang',
  触: 'chu',
  发: 'fa',
  错: 'cuo',
  误: 'wu',
  个: 'ge',
  人: 'ren',
  中: 'zhong',
  心: 'xin',
  设: 'she',
  置: 'zhi',
  退: 'tui',
  出: 'chu',
  图: 'tu',
  形: 'xing',
  编: 'bian',
  辑: 'ji',
  器: 'qi',
  流: 'liu',
  程: 'cheng',
  脑: 'nao',
  拓: 'tuo',
  扑: 'pu',
  签: 'qian',
  源: 'yuan',
  站: 'zhan',
  主: 'zhu',
  翻: 'fan',
  译: 'yi',
  推: 'tui',
  荐: 'jian',
  聚: 'ju',
  合: 'he',
  导: 'dao',
  报: 'bao',
  留: 'liu',
  存: 'cun',
  同: 'tong',
  服: 'fu',
  务: 'wu',
  端: 'duan',
  事: 'shi',
  件: 'jian',
  户: 'hu',
  指: 'zhi',
  额: 'e',
  黑: 'hei',
  名: 'ming',
  记: 'ji',
  送: 'song',
  白: 'bai',
  策: 'ce',
  略: 'lue',
  命: 'ming',
  版: 'ban',
  本: 'ben',
  增: 'zeng',
  长: 'zhang',
  配: 'pei',
  广: 'guang',
  告: 'gao',
  组: 'zu',
  全: 'quan',
  局: 'ju',
  位: 'wei',
  客: 'ke',
  实: 'shi',
  验: 'yan',
  引: 'yin',
  装: 'zhuang',
  修: 'xiu',
  方: 'fang',
  案: 'an',
  池: 'chi',
  反: 'fan',
  馈: 'kui',
  阅: 'yue',
  读: 'du',
  汇: 'hui',
  总: 'zong',
  空: 'kong',
  间: 'jian',
  系: 'xi',
  统: 'tong',
  维: 'wei',
  护: 'hu',
  后: 'hou',
  权: 'quan',
  限: 'xian',
  目: 'mu',
  审: 'shen',
  计: 'ji',
  任: 'ren',
  缓: 'huan',
  混: 'hun',
  淆: 'xiao',
  域: 'yu',
  网: 'wang',
  关: 'guan',
  测: 'ce',
  试: 'shi',
  通: 'tong',
  知: 'zhi',
  桥: 'qiao',
  接: 'jie',
  包: 'bao',
  类: 'lei',
  型: 'xing',
  演: 'yan',
  示: 'shi',
  清: 'qing',
  除: 'chu',
};

const normalize = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[\s._/-]+/g, '');

export const menuSearchTokens = (label: string) => {
  const text = normalize(label);
  const chars = Array.from(label);
  const pinyin = chars
    .map((char) => PINYIN_BY_CHAR[char] || (/[\w]/.test(char) ? char : ''))
    .join('');
  const initials = chars
    .map((char) => {
      const pinyin = PINYIN_BY_CHAR[char];
      if (pinyin) return pinyin[0];
      return /[a-zA-Z0-9]/.test(char) ? char.toLowerCase() : '';
    })
    .join('');
  return [text, normalize(pinyin), normalize(initials)].filter(Boolean);
};

export const menuLabelMatches = (label: string, keyword: string) => {
  const normalizedKeyword = normalize(keyword);
  if (!normalizedKeyword) return true;
  return menuSearchTokens(label).some((token) =>
    token.includes(normalizedKeyword),
  );
};
